import React, { useState } from "react";
import { Form, Button, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import axios from "axios";
import estilos from "./Settings.module.css";

export function Settings() {
  const [showPasswordOld, setShowPasswordOld] = useState(false);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const { auth } = useAuth();

  async function getUser() {
    try {
      const response = await axios.get(`${BASE_API}/api/users/${auth.me.id}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function updatePassword(data) {
    try {
      const url = `${BASE_API}/api/change_password/${auth.me.id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };

      const response = await fetch(url, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(data),
      });

      if (response.status === 401) {
        window.location.reload();
        window.location.href = "/Login";
      }
      if (response.status !== 200 && response.status !== 401) {
        toast.error("La contraseña antigua ingresada es incorrecta");
      } else {
        toast.success("Contraseña Actualizada con éxito");
        formik.resetForm();
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {}
  }

  const formik = useFormik({
    initialValues: {
      old_password: "",
      password: "",
      password2: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required(
        "La contraseña antigua es obligatoria"
      ),
      password: Yup.string()
        .required("La contraseña es obligatoria")
        .min(8, "La contraseña debe tener al menos 8 caracteres")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
          "La contraseña debe contener al menos una mayúscula, una minúscula, un número y un símbolo"
        ),
      password2: Yup.string()
        .required("La confirmación de la contraseña es obligatoria")
        .oneOf([Yup.ref("password")], "Las contraseñas no coinciden"),
    }),
    validateOnChange: true,
    onSubmit: async (formValue) => {
      try {
        await updatePassword(formValue);
      } catch (error) {
        window.location.reload();
        window.location.href = "/Login";
      }
    },
  });

  const passwordValidation = {
    minLength: formik.values.password.length >= 8,
    hasUppercase: /[A-Z]/.test(formik.values.password),
    hasLowercase: /[a-z]/.test(formik.values.password),
    hasNumber: /\d/.test(formik.values.password),
    hasSpecialChar: /[@$!%*?&]/.test(formik.values.password),
  };

  return (
    <div>
      <h1 className="tituloin">Cambiar contraseña</h1>

      <div className={estilos.rectangulo} onSubmit={formik.handleSubmit}>
        <Form>
          Contraseña anterior:
          <Form.Input
            name="old_password"
            type={showPasswordOld ? "text" : "password"}
            placeholder="Contraseña anterior"
            icon={{
              name: showPasswordOld ? "eye" : "eye slash",
              link: true,
              onClick: () => setShowPasswordOld(!showPasswordOld),
            }}
            value={formik.values.old_password}
            onChange={formik.handleChange}
            error={formik.errors.old_password}
            className={estilos.in}
          />
          Nueva Contraseña:
          <Form.Input
            name="password"
            type={showPasswordNew ? "text" : "password"}
            placeholder="Nueva Contraseña"
            icon={{
              name: showPasswordNew ? "eye" : "eye slash",
              link: true,
              onClick: () => setShowPasswordNew(!showPasswordNew),
            }}
            value={formik.values.password}
            onChange={formik.handleChange}
            className={estilos.in}
          />
          <div
            style={{
              fontSize: "12px",
              lineHeight: "1",
              padding: "0",
              margin: "0",
              marginBottom: "8px",
            }}
          >
            {[
              {
                condition: passwordValidation.minLength,
                text: "Mínimo 8 caracteres",
              },
              {
                condition: passwordValidation.hasUppercase,
                text: "Al menos una mayúscula",
              },
              {
                condition: passwordValidation.hasLowercase,
                text: "Al menos una minúscula",
              },
              {
                condition: passwordValidation.hasNumber,
                text: "Al menos un número",
              },
              {
                condition: passwordValidation.hasSpecialChar,
                text: "Al menos un carácter especial (@$!%*?&)",
              },
            ].map(({ condition, text }, index) => (
              <p
                key={index}
                style={{ display: "flex", alignItems: "center", margin: "0" }}
              >
                <Icon
                  name={condition ? "check" : "close"}
                  color={condition ? "green" : "red"}
                  size="small"
                  style={{ marginRight: "5px" }}
                />
                {text}
              </p>
            ))}
          </div>
          Confirma la nueva contraseña:
          <Form.Input
            name="password2"
            type={showPasswordConfirm ? "text" : "password"}
            placeholder="Confirmar nueva contraseña"
            icon={{
              name: showPasswordConfirm ? "eye" : "eye slash",
              link: true,
              onClick: () => setShowPasswordConfirm(!showPasswordConfirm),
            }}
            value={formik.values.password2}
            onChange={formik.handleChange}
            error={formik.errors.password2}
            className={estilos.in}
          />
          <Button
            type="submit"
            content="Actualizar contraseña"
            style={{ backgroundColor: "#008e86", color: "white" }}
            fluid
            disabled={
              !(
                passwordValidation.minLength &&
                passwordValidation.hasUppercase &&
                passwordValidation.hasLowercase &&
                passwordValidation.hasNumber &&
                passwordValidation.hasSpecialChar
              )
            }
          />
        </Form>
        <ToastContainer
          position="bottom-center"
          autoClose={1500}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
        />
      </div>
    </div>
  );
}
